import styled from '@emotion/styled';
import { rem } from 'polished';
import React from 'react';
import $ from 'text2vdom';

import { css, scale, scaledCss } from '~/css';

import * as ArrowButton from './ArrowButton';
import RepeatContainer from './RepeatContainer';
import { CarouselProps } from './types';

interface DotsProps extends CarouselProps {
  textSize: 'medium' | 'large';
  arrows?: boolean;
}

const Container = styled('div')(
  css({
    position: 'relative',
    width: [undefined, undefined, '690px'],
    margin: [undefined, undefined, '0 auto'],
  }),
);

interface DotProps {
  active: boolean;
  textSize: 'medium' | 'large';
  far?: boolean;
}
const Dot = styled('div')((props: DotProps) =>
  scaledCss({
    flexShrink: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '50%',
    border: '1px solid #4db2a3',
    cursor: 'pointer',
    transitionProperty: 'color, background, opacity',
    transitionDuration: '0.2s',
    userSelect: 'none',
    whiteSpace: 'pre-line',
    lineHeight: 1.1,
    boxSizing: 'border-box',
    // Variable props
    fontWeight: props.active ? 'bold' : 'normal',
    background: props.active ? '#4db2a3' : '#fff',
    color: props.active ? '#fff' : '#4db2a3',
    opacity: props.far ? 0.4 : 1,
    // Responsive props
    marginX: [scale(12 / 2), scale(12 / 2), rem(30 / 2)],
    width: [scale(125), scale(125), rem(110)],
    height: [scale(125), scale(125), rem(110)],
    padding: [scale(1), scale(1), 0],
    fontSize: {
      medium: [scale(16), scale(16), rem(16)],
      large: [scale(25), scale(25), rem(20)],
    }[props.textSize],
    ':lang(ja)': {
      fontSize: {
        medium: [scale(14), scale(14), rem(14)],
        large: [scale(25), scale(25), rem(20)],
      }[props.textSize],
    },
  })(props),
);

const Dots: React.FC<DotsProps> = ({
  textSize,
  items,
  currentIndex,
  setCurrentIndex,
  goPrev,
  goNext,
  arrows = false,
}) => {
  const handleClickDot = (index: number) => {
    if (setCurrentIndex) {
      setCurrentIndex(index);
    }
  };

  return (
    <Container>
      {arrows && <ArrowButton.Prev onClick={goPrev} />}
      <RepeatContainer
        currentIndex={currentIndex}
        panelSize={[scale(125 + 12), scale(125 + 12), rem(110 + 30)]} // width + margin
      >
        {items.map((item, index) => (
          <Dot
            key={index}
            textSize={textSize}
            active={index === currentIndex}
            far={Math.abs(currentIndex - index) > 1}
            onClick={() => handleClickDot(index)}
          >
            {$(item.navigationTitle ?? item.title)}
          </Dot>
        ))}
      </RepeatContainer>
      {arrows && <ArrowButton.Next onClick={goNext} />}
    </Container>
  );
};

export default Dots;
